/**
 * useActivationComposerData — le contexte du composeur, quelle que soit la porte.
 *
 * Par LIEN SIGNÉ : l'écran refait son propre GET plutôt que d'espérer des paramètres riches dans
 * l'URL — c'est ce qui le fait survivre à un rechargement à froid. Par le PORTAIL : Redux porte
 * déjà tout, aucun fetch (`ActivationComposerScreen.js:113-201`).
 *
 * Il rend aussi l'AMORCE du brouillon et sa clé d'identité : l'offre recommandée n'arrive parfois
 * qu'après le premier rendu, et c'est ce qui déclenche la re-synchronisation du formulaire.
 */
import { useSelector } from "react-redux"

import { subscriptionService } from "../../../../../../data/services/subscriptionService"
import {
    soldNoCommitmentHoursByOffer,
    toActivationDraftSeed,
    type ApiActivationLinkContext,
} from "../../../../adapters/parent/Activation/activationAdapter"
import { readActivationComposerSources } from "../../../../view-models/parent/Activation/activationComposerViewModel"
import { useApiFetch } from "../../../hooks/useApiFetch"
import { type ActivationLinkParams } from "./activationLink"

export function useActivationComposerData(linkParams: ActivationLinkParams | null) {
    const fromLink = linkParams != null

    const { raw } = useApiFetch<ApiActivationLinkContext>({
        service: subscriptionService.getActivationLinkContext,
        urlParams: linkParams ?? {},
        requestKey: linkParams ? `${linkParams.u}:${linkParams.sig}` : null,
        enabled: fromLink,
    })

    const sources = useSelector((state: unknown) => readActivationComposerSources(state, raw, fromLink))

    const seed = toActivationDraftSeed(sources)
    const soldNoCommitmentHours = soldNoCommitmentHoursByOffer(sources)

    return {
        raw,
        fromLink,
        isModification: sources.activation?.planned != null,
        seed,
        soldNoCommitmentHours,
        /**
         * L'identité de l'amorce, pas sa référence : `sources` est reconstruit à chaque rendu, et
         * un effet de re-synchronisation calé dessus repartirait en boucle.
         */
        seedKey: JSON.stringify([seed, soldNoCommitmentHours]),
    }
}
